// StyledTooltip.tsx
import { FC, ReactElement } from "react";
import { Tooltip, TooltipProps } from "@mui/material";
import styles from "./SubmitStyledTooltip.module.scss";

interface SubmitStyledTooltipProps {
  children: ReactElement;
  placement?: TooltipProps["placement"];
}

const SubmitStyledTooltip: FC<SubmitStyledTooltipProps> = ({
  children,
  placement = "bottom",
}) => {
  return (
    <Tooltip
      title={
        <div className={styles["custom-tooltip"]}>
          <div className={styles["custom-tooltip__arrow"]}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="7"
              viewBox="0 0 16 7"
              fill="currentColor"
            >
              <path
                d="M9.83219 0.757969L16 6.92578L-3.49691e-07 6.92578L6.16781 0.75797C7.1797 -0.25392 8.8203 -0.253922 9.83219 0.757969Z"
                fill="currentColor"
              />
            </svg>
          </div>
          <div className={styles["custom-tooltip__content"]}>Submit</div>
        </div>
      }
      enterDelay={0}
      leaveDelay={0}
      enterNextDelay={0}
      TransitionProps={{ timeout: 0 }}
      placement={placement}
      arrow={false}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "transparent",
            padding: 0,
            maxWidth: "none",
          },
        },
        popper: {
          sx: {
            pointerEvents: "none",
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default SubmitStyledTooltip;
